module.exports = __webpack_public_path__ + "static/media/iphone6-2up-expanded.c2c73c5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphone/iphone6/iphone6-2up-expanded.svg
// module id = 33
// module chunks = 0